var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entity-picker" }, [
    _c("div", { staticClass: "search-panel" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query",
          },
        ],
        attrs: {
          maxlength: "128",
          placeholder: _vm.$t("chatbotv2.typeSearchValue"),
          type: "text",
        },
        domProps: { value: _vm.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "entity-list" }, [
      _c(
        "div",
        { staticClass: "entity-select" },
        [
          _vm.userEntities.length
            ? _c("div", { staticClass: "text-uppercase caption" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.userEntities"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.entitiesUser, function (entity) {
            return _vm.userEntities.length
              ? _c(
                  "div",
                  {
                    staticClass: "picker-item",
                    class: {
                      active: _vm.defaultSelected === "user_" + entity.name,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.pick("user_" + entity.name)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(entity.name) + " "),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "description" }),
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-uppercase caption" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.systemEntities"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.entitiesSystem, function (entity) {
            return _c(
              "div",
              {
                staticClass: "picker-item",
                class: { active: _vm.defaultSelected === entity.value },
                on: {
                  click: function ($event) {
                    return _vm.pick(entity.value)
                  },
                },
              },
              [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2." + entity.value)) + " "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("chatbotv2." + entity.value + "Description")
                      ) +
                      "\n                "
                  ),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }